import { render, staticRenderFns } from "./beginning-of-year.vue?vue&type=template&id=2d8baccd&"
import script from "./beginning-of-year.vue?vue&type=script&lang=js&"
export * from "./beginning-of-year.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports